
export default class SaleBrowseEvents {
    public onlyCreatorEdit = true
    public onlyCreatorDelete = true
}
